// @flow

import type { Saga } from 'redux-saga';
import { call, put, select } from 'redux-saga/effects';
import ApiNotifications from '~/sdk/notifications/email/ApiNotifications';
import { getVerticalId } from '~/common/selectors/config';
import mapSubscriptionResponse from '../adapters/subscriptionResponse';
import { openSnackbarError, closeSnackbar } from '../Snackbar/actions';
import { setNewsletterNotifications } from '../NewsletterNotifications/actions';
import { setSearchNotifications } from '../SearchNotifications/actions';
import {
  setIsFetchingNotifications,
  unsetIsFetchingNotifications,
} from '../LoaderNotifications/actions';
import { notificationApiParamsSelector } from '../selectors';

export default (notificationsApi: ApiNotifications) =>
  function* fetchNotificationsSaga(): Saga<void> {
    yield put(setIsFetchingNotifications());
    yield put(closeSnackbar());

    const apiParams = yield select(notificationApiParamsSelector);

    try {
      const response = yield call(
        [notificationsApi, notificationsApi.getUserSubscription],
        apiParams
      );

      const verticalId = yield select(getVerticalId);
      const mappedResponse = mapSubscriptionResponse(verticalId, response);

      yield put(setSearchNotifications(mappedResponse.searchNotifications));
      yield put(setNewsletterNotifications(mappedResponse.newsletterNotifications));
      yield put(unsetIsFetchingNotifications());
    } catch (error) {
      yield put(openSnackbarError());
      yield put(unsetIsFetchingNotifications());
    }
  };



// WEBPACK FOOTER //
// ./app/NotificationsManager/email/sagas/fetchNotifications.js